<template>
  <div
    v-if="loader"
    :class="`flex flex-col justify-center items-center ${loaderSize} select-none`"
  >
    <section
      v-if="loaderType === 'progress'"
      class="flex flex-col flex-wrap justify-center text-center"
    >
      <p class="mb-5 text-h-primary-500 text-2xl font-bold">{{ label }}</p>
      <ProgressBar
        mode="indeterminate"
        class="progressbar-style w-80"
        style="height: 0.5em"
      />
    </section>

    <section
      v-if="loaderType === 'spinner'"
      class="flex flex-col justify-center text-center"
    >
      <ProgressSpinner :style="setSpinnerSize()" />
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "loader",
  props: {
    loader: Boolean,
    label: String,
    loaderType: {
      type: String,
      default: "spinner",
    },
    loaderSize: {
      type: String,
      default: "h-screen",
    },
    spinnerSize: {
      type: String,
      default: "large",
    },
  },
  methods: {
    setSpinnerSize(): { width: string; height: string } {
      if (this.spinnerSize === "small")
        return { width: "2rem", height: "2rem" };
      else if (this.spinnerSize === "medium")
        return { width: "4rem", height: "4rem" };
      else if (this.spinnerSize === "large")
        return { width: "7rem", height: "7rem" };

      return { width: "", height: "" };
    },
  },
});
</script>
